import React from 'react';
import { useNavigate } from 'react-router-dom';
// import { signOut } from 'firebase/auth';
// import { auth } from 'firebase.config';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Fade, Button, ClickAwayListener, Paper, Popper, List, ListItemText, ListItemIcon, ListItemButton } from '@mui/material';

// assets
import PersonTwoToneIcon from '@mui/icons-material/PersonTwoTone';
// import DraftsTwoToneIcon from '@mui/icons-material/DraftsTwoTone';
// import LockOpenTwoTone from '@mui/icons-material/LockOpenTwoTone';
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone';
// import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';
import MeetingRoomTwoToneIcon from '@mui/icons-material/MeetingRoomTwoTone';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
const ProfileSection = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const accessToken = localStorage.getItem('accessToken');

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    navigate('/');
  };

  const handleContact = () => {
    window.open('https://neophyte.ai', '_blank');
  };

  const [selectedIndex, setSelectedIndex] = React.useState();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const handleProfileClick = (event) => {
    handleListItemClick(event, 1);
    navigate('/main/profile'); // Keep this absolute path for navigation
    handleClose(event);
  };

  const handleSettingsClick = (event) => {
    handleListItemClick(event, 0);
    navigate('/main/settings'); // Navigate to settings page
    handleClose(event);
  };

  // if (!auth) {
  //   return null; // or render a loading/error message
  // }

  return (
    <>
      <Button
        sx={{
          minWidth: { sm: 50, xs: 35 },
          color: 'black',
          position: 'absolute',
          right: { xs: 30, sm: 'auto', lg: 20 },
          top: { xs: 10, sm: 'auto' }
        }}
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        aria-label="Profile"
        onClick={handleToggle}
        color="inherit"
      >
        <AccountCircleOutlinedIcon sx={{ fontSize: '1.8rem' }} />
      </Button>

      {accessToken ? (
        <Popper
          placement="bottom-end"
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
          modifiers={[
            {
              name: 'offset',
              options: {
                offset: [0, 10]
              }
            },
            {
              name: 'preventOverflow',
              options: {
                altAxis: true
              }
            }
          ]}
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps}>
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <List
                    sx={{
                      width: '100%',
                      maxWidth: 350,
                      minWidth: 250,
                      bgcolor: theme.palette.background.paper,
                      pb: 0,
                      borderRadius: '10px'
                    }}
                  >
                    <ListItemButton selected={selectedIndex === 0} onClick={handleSettingsClick}>
                      <ListItemIcon>
                        <SettingsTwoToneIcon />
                      </ListItemIcon>
                      <ListItemText primary="Settings" />
                    </ListItemButton>
                    <ListItemButton selected={selectedIndex === 1} onClick={handleProfileClick}>
                      <ListItemIcon>
                        <PersonTwoToneIcon />
                      </ListItemIcon>
                      <ListItemText primary="Profile" />
                    </ListItemButton>

                    {/* <ListItemButton selected={selectedIndex === 2} onClick={(event) => handleListItemClick(event, 2)}>
                    <ListItemIcon>
                      <DraftsTwoToneIcon />
                    </ListItemIcon>
                    <ListItemText primary="My Messages" />
                  </ListItemButton> */}
                    {/* <ListItemButton selected={selectedIndex === 3} onClick={(event) => handleListItemClick(event, 3)}>
                    <ListItemIcon>
                      <LockOpenTwoTone />
                    </ListItemIcon>
                    <ListItemText primary="Lock Screen" />
                  </ListItemButton> */}
                    {/* <Link to={'/login'}> */}

                    <ListItemButton selected={selectedIndex === 4} onClick={handleContact}>
                      <ListItemIcon>
                        <ContactMailOutlinedIcon />
                      </ListItemIcon>
                      <ListItemText primary="Contact Us" />
                    </ListItemButton>

                    <ListItemButton selected={selectedIndex === 5} onClick={handleLogout}>
                      <ListItemIcon>
                        <MeetingRoomTwoToneIcon />
                      </ListItemIcon>
                      <ListItemText primary="Logout" />
                    </ListItemButton>

                    {/* </Link> */}
                  </List>
                </ClickAwayListener>
              </Paper>
            </Fade>
          )}
        </Popper>
      ) : (
        <>No users found</>
      )}
    </>
  );
};

export default ProfileSection;
